module.exports = {
  "id": "forest floor",
  "title": "forest floor",
  "image": "provision/parts/forest floor/forest floor.png",
  "info": [
    {
      "text": "Add a forest floor platform to your project",
      "image": "provision/parts/forest floor/forest floor.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/forest floor/forest floor.png"
};